import React from "react";
import { QRProps } from "@/contexts/QREditorContext/types";
import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { PreviewUrlUnified } from "@/features/previews/shared/components/PreviewUrlUnified/PreviewUrlUnified";
import { useUrlData } from "./hooks/useUrlData";
import "./UrlTemplate.scss";

export function UrlTemplate(props: QRProps<"url">) {
  const { qrUrlLink, translations, isInitPreview, preview } = useUrlData(props);

  return (
    <div className="url-template">
      <PhoneLayout
        page="url"
        dataQA="preview-url-container"
        isInitPreview={isInitPreview}
      >
        <PreviewUrlUnified
          qrUrlLink={qrUrlLink}
          translations={translations}
          preview={preview}
        />
      </PhoneLayout>
    </div>
  );
}
